<template>
    <component :is="component" :collectionData="collectionData" :paginationData="paginationData" v-if="component"/>
</template>

<script>
    export default {
        name: "CollectionListLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
          listLayout: {},
          collectionData: {
            type: Array,
            default: () => {
              return []
            }
          },
          paginationData: {
            type: Object,
            default: {
              total: 0,
              page: 0,
              size: 0,
            }
          },
        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.listLoader()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.listLayout) {
                    return null
                }
                return () => import(`@/template/collection/list/${this.listLayout}`)
            },
        },
        methods: {
          listLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/collection/list/CollectionListDefaultLayout')
                    })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>